import airspaceIcon from 'assets/icons/nav-airspace.svg';
import streamingIcon from 'assets/icons/nav-streaming.svg';
import manageIcon from 'assets/icons/nav-manage.svg';
import reportsIcon from 'assets/icons/nav-reports.svg';
import settingsIcon from 'assets/icons/nav-settings.svg';
import { t } from 'i18next';

export const getDefaultNavigationItems = () => [
	{
		name: t('Airspace'),
		path: 'airspace',
		value: 'airspace',
		icon: <img src={airspaceIcon} />
	},
	{
		name: t('Streaming'),
		path: 'streaming',
		value: 'stream',
		featureValue: 'stream',
		icon: <img src={streamingIcon} />
	},
	{
		name: t('Manage'),
		path: 'manage',
		value: 'manage',
		icon: <img src={manageIcon} />
	},
	{
		name: t('Reports'),
		path: 'reports',
		value: 'reports',
		featureValue: 'report',
		icon: <img src={reportsIcon} />
	},
	{
		name: t('Account Settings'),
		path: 'settings',
		value: 'settings',
		icon: <img src={settingsIcon} />
	}
];
